var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgProfileEmail = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 32,
  height: 32,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 16,
  cy: 16,
  r: 16,
  fill: "#0564AA"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M7.75 8a2.258 2.258 0 0 0-2.25 2.25v12a2.258 2.258 0 0 0 2.25 2.25h16.5a2.258 2.258 0 0 0 2.25-2.25v-12A2.258 2.258 0 0 0 24.25 8H7.75Zm0 1.5h16.5c.053 0 .094.018.14.03L16 15.335 7.61 9.529c.046-.011.087-.029.14-.029ZM7 10.93l9 6.234 9-6.234v10.623l-4.71-3.944L19 18.5l5.361 4.477c-.035.005-.07.023-.111.023H7.75c-.041 0-.076-.018-.111-.023L13 18.5l-1.29-.89L7 21.552V10.93Z",
  fill: "#fff"
})));
export default SvgProfileEmail;